export const USERS_URL = 'users';

export const MEMBERS_URL = 'users/all';

export const INVITE_USER_URL = 'users/invite';

export const UPDATE_MEMBER_URL = 'users/role';
